import { Check } from '../asset';
import style from './style';
import type { VBaseSelectItemProps } from './type';

const VBaseSelectItemCheck = ({
  label,
  selected,
}: Pick<VBaseSelectItemProps, 'label' | 'selected'>) => {
  return (
    <div
      aria-checked={selected}
      aria-labelledby={`${label}`}
      role="checkbox"
      title={`${label}`}
    >
      <Check className={style.vBaseSelectItemCheckIcon(selected)} />
    </div>
  );
};

VBaseSelectItemCheck.displayName = 'VBaseSelectItemCheck';

export default VBaseSelectItemCheck;
